import { render, staticRenderFns } from "./Yacht.vue?vue&type=template&id=c2bbcac4"
import script from "./Yacht.vue?vue&type=script&lang=js"
export * from "./Yacht.vue?vue&type=script&lang=js"
import style0 from "./Yacht.vue?vue&type=style&index=0&id=c2bbcac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports